//- Remunerations headers for employee details tab
import moment from 'moment'
export default[
    {
        text: 'Debe',
        sortable: false,
        value: 'debt',
    },
    {
        text: 'Haber',
        sortable: false,
        value: 'receive',
    },
]
